"use client";

import { Typography } from "react-vant";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/03-presenters/components/ui/tooltip";
import { cx } from "class-variance-authority";
import { Portal } from "@radix-ui/react-tooltip";
export default function Ellipsis({
  title,
  children,
  ellipsis = 1,
  className,
  contentClassName
}: {
  title: string | number;
  children: React.ReactNode;
  ellipsis?: number;
  className?: string;
  contentClassName?: string;
}) {
  return <TooltipProvider delayDuration={200} data-sentry-element="TooltipProvider" data-sentry-component="Ellipsis" data-sentry-source-file="Ellipsis.tsx">
      <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="Ellipsis.tsx">
        <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="Ellipsis.tsx">
          {/* 这里要用div包一层 否则tooltip不生效 */}
          <div className={cx("cursor-pointer", className)}>
            <Typography.Text ellipsis={ellipsis} data-sentry-element="unknown" data-sentry-source-file="Ellipsis.tsx">{children}</Typography.Text>
          </div>
        </TooltipTrigger>
        <Portal data-sentry-element="Portal" data-sentry-source-file="Ellipsis.tsx">
          <TooltipContent className="cursor-text select-text bg-gray-1" data-sentry-element="TooltipContent" data-sentry-source-file="Ellipsis.tsx">
            <div className={cx("w-56", contentClassName)} onClick={e => e.preventDefault()}>
              {title}
            </div>
          </TooltipContent>
        </Portal>
      </Tooltip>
    </TooltipProvider>;
}